import { RelationalActionParameter } from "./RelationalActionParameter";
import { IItem } from "./IItem";

export interface IRelatedExternalScriptExecutable {
  scriptExecuteParameters: RelationalActionParameter[];
  isValueUpdated(oldItem: IItem): boolean;
}

export function instanceOfIRelatedExternalScriptExecutable(instance: any): instance is IRelatedExternalScriptExecutable {
  return instance
    && (instance.scriptExecuteParameters !== undefined)
    && (instance.isValueUpdated !== undefined);
}
